import { ItemModelDto } from '@treasury/api/channel';

export const defaultItemModel: ItemModelDto = {
    amount: 0,
    customer: undefined,
    frontImage: '',
    rearImage: '',
};
